export default __webpack_public_path__ + "static/media/SENAIT_NL_SEQ06A.db2842da.mp3";